import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Card, Typography } from '@chilecompra/react-kit/components'
import { GridContainer, GridItem, LinkDate, Tag } from './QuoteBid.styles'
import { useAuthorization } from '../AuthorizationProvider/AuthorizationProvider.hooks'
import { useHasReachedMaxDate } from '../../modules/hooks/maxDate'

/**
 * The Quote Bid Quantity's component.
 */
const QuoteBidQuantity = props => {
  const { quoteQuantity, onExtendClosingDate, statusCallAgile } = props
  const { authInfo } = useSelector(state => state.authorizationProvider)
  const { isBuyer } = useAuthorization()
  const hasReachedMaxDate = useHasReachedMaxDate()

  return (
    <GridContainer margin="41px 0 48px">
      <GridItem md={9} xs={12}>
        <GridContainer padding="0 0 6px">
          <GridItem container alignItems="center" xs={12}>
            <Typography color="black1" fontSize="22px" fontWeight="bold" lineHeight="26px" variant="h3">
              Listado de proveedores que cotizaron
            </Typography>
            <Tag color="primary" margin="0 0 0 24px" text={statusCallAgile.call} />
          </GridItem>
        </GridContainer>
        <GridContainer padding="4px 0 0">
          <GridItem xs={12}>
            <Typography color="black1" fontSize="14px" lineHeight="18px" variant="body2">
              Por el momento solamente podrás revisar la cantidad de cotizaciones recibidas y ampliar la fecha de
              cierre.
            </Typography>
          </GridItem>
        </GridContainer>
        <GridContainer padding="16px 0 0">
          <GridItem xs={12}>
            <Card color="blank" elevation="2">
              <GridContainer>
                <GridItem xs={12}>
                  <Typography color="black1" fontSize="20px" fontWeight="black" lineHeight="26px" variant="h3">
                    Has recibido {quoteQuantity} {quoteQuantity > 1 ? 'cotizaciones' : 'cotización'}.
                  </Typography>
                </GridItem>
              </GridContainer>
              <GridContainer padding="4px 0 0">
                <GridItem xs={12}>
                  {isBuyer ? (
                    <Typography color="black1" fontSize="16px" lineHeight="20px" variant="body1">
                      Una vez finalizado el periodo de publicación, podrás revisar el detalle de cada cotización.
                    </Typography>
                  ) : (
                    <Typography color="black1" fontSize="16px" lineHeight="20px" variant="body1">
                      Las cotizaciones están siendo revisadas y evaluadas por el organismo comprador.
                    </Typography>
                  )}
                </GridItem>
              </GridContainer>
              <GridContainer
                visibility={authInfo.hasObserverRole || hasReachedMaxDate ? 'hidden' : 'visible'}
                padding="8px 0 0"
              >
                <GridItem xs={12}>
                  <LinkDate onClick={onExtendClosingDate}>Ampliar fecha de cierre</LinkDate>
                </GridItem>
              </GridContainer>
            </Card>
          </GridItem>
        </GridContainer>
      </GridItem>
      <GridItem md={3} xs={12} />
    </GridContainer>
  )
}

QuoteBidQuantity.propTypes = {
  quoteQuantity: PropTypes.number.isRequired,
  onExtendClosingDate: PropTypes.func.isRequired,
  statusCallAgile: PropTypes.objectOf(PropTypes.any).isRequired
}

export default QuoteBidQuantity
